import { LoggerAwareAsyncConstructable as d } from "./logger/loggerAwareAsyncConstructable.js";
import { withGC as l } from "./pyodide/gc.js";
import { loadPyodide as b } from "./pyodide/loadPyodide.js";
import "./pyodide/pyodideContext.js";
const h = new FinalizationRegistry((o) => {
  o.destroy();
});
class u extends d {
  constructor(t, r, s, c, n, y, a = []) {
    const p = (async () => {
      const i = await b(s, c, n, y, ...a), e = await r(i);
      return this.pyodide = i, this.pyObject = e, e && h.register(this, e), { pyodide: i, pyObject: e };
    })();
    super(t, p), this.logger = t;
  }
  logger;
  pyodide;
  pyObject;
  propertyToJs(t) {
    return l(this.pyObject[t]).toJS();
  }
  async close() {
    this.isInitialized && this.pyObject.destroy();
  }
}
export {
  u as PyodideObjectAsyncConstructable
};
